// const horizontalTimeline = document.querySelector('.splide.horizontal-timeline');
// const paginationScroll = document.getElementById('pagination-scroll');

// if (horizontalTimeline) {

//     const horizontalSplide = new Splide(horizontalTimeline, {
//         type: 'slide',
//         fixedWidth: '450px',
//         gap: '100px',
//         perMove: 1,
//         arrows: false,
//         pagination: false,
//         wheel: true,
//         focus: 'center',
//         drag: 'free',
//         waitForTransition: true,
//     }).mount();

//     paginationScroll.max = (horizontalSplide.Components.Controller.getEnd() + 1) * 10; // Adjust max range for smooth control

//     // Calculate and set thumb width
//     function updateThumbWidth() {
//         var totalSlides = horizontalSplide.length;
//         var visibleSlides = horizontalSplide.options.perPage;
//         var thumbWidthPercentage = (visibleSlides / totalSlides) * 100;
//         var minThumbWidth = 10; // Set a minimum width for the thumb (in pixels)
//         var maxThumbWidth = 50; // Set a maximum width for the thumb (in pixels)

//         // Calculate the actual thumb width based on the percentage
//         var thumbWidth = Math.max(minThumbWidth, Math.min(maxThumbWidth, thumbWidthPercentage));

//         // Update the thumb width dynamically using CSS variables
//         paginationScroll.style.setProperty('--thumb-width', `${thumbWidth}px`);
//     }
//     updateThumbWidth();
//     paginationScroll.addEventListener('input', function () {
//         var percentage = paginationScroll.value / paginationScroll.max;
//         var targetIndex = Math.round(percentage * (horizontalSplide.length - 1)); // Calculate the slide to go to
//         horizontalSplide.go(targetIndex);
//     });
//     horizontalSplide.on('move', function (newIndex) {
//         var percentage = (newIndex / (horizontalSplide.length - 1)) * paginationScroll.max;
//         paginationScroll.value = percentage;
//     });
//     window.addEventListener('resize', updateThumbWidth);
// };

document.addEventListener('DOMContentLoaded', function () {
    const horizontalTimeline = document.querySelector('.splide.horizontal-timeline');
    const horizontalSplide = new Splide(horizontalTimeline, {
        type: 'slide',
        fixedWidth: '450px',
        gap: '100px',
        perMove: 1,
        arrows: false,
        pagination: false,
        wheel: true,
        focus: 'center',
        drag: false,
        waitForTransition: true,
        breakpoints: {
          512: {
            fixedWidth: '350px',
          }
        }
    }).mount();
    
    // Get the range input element
    var paginationScroll = document.getElementById('pagination-scroll');
  
    // Update the range input's max value based on the number of total slides
    paginationScroll.max = (horizontalSplide.Components.Controller.getEnd() + 1) * 10; // Adjust max range for smooth control
  
    // Listen for range input changes to move the slider
    paginationScroll.addEventListener('input', function () {
      var percentage = paginationScroll.value / paginationScroll.max;
      var targetIndex = Math.round(percentage * (horizontalSplide.length - 1)); // Calculate the slide to go to
      horizontalSplide.go(targetIndex);
    });
  
    // Update range slider when Splide moves via dragging or navigation
    horizontalSplide.on('move', function (newIndex) {
      var percentage = (newIndex / (horizontalSplide.length - 1)) * paginationScroll.max;
      paginationScroll.value = percentage;
    });
  });